import React, { forwardRef } from "react";
import ContentCard from "../ContentCard/ContentCard";
import Tag, { TagType } from "../../Tag/Tag";
import TopBulgemask from "../../../assets/masks/Basic/section-top-bulge-mobile.svg";
import Bell from "../../../assets/icons/Blog/bell.svg";
import Bookmark from "../../../assets/icons/Blog/bookmark.svg";
import Iso from "../../../assets/icons/iso_green.svg";
import { MaskType } from "../../MaskShapeContainer/MaskShapeContainer";
import AuthorArticle from "./AuthorArticle";

export type ArticlePreview = {
  image?: React.ReactNode;
  title: string;
  summary: string;
  thumbnail?: {
    url: string;
    alt?: string;
  };
  redirectTo?: string,
};

interface IAuthorCardDesktop {
  authorImage?: string;
  authorName: string;
  authorRole: string;
  numArticles?: number;
  featuredArticles?: ArticlePreview[];
  height?: string;
  width?: string;
  className?: string;
  isSpeaker?: boolean;
  isAtSpeaker?: boolean;
  title?: string;
  content?: string;
}

const AuthorCardDesktop = forwardRef<HTMLDivElement, IAuthorCardDesktop>(
  (
    {
      authorImage,
      authorName,
      authorRole,
      numArticles,
      featuredArticles,
      className,
      height = "h-full",
      width = "w-full",
      isSpeaker = false,
      isAtSpeaker = false,
      title,
      content,
    },
    ref
  ) => {
    return (
      <div ref={ref} className={`${height} ${width} ${className}`}>
        <ContentCard
          imageContentStyle="h-[35%]"
          textContentStyle="h-[70%]"
          maskType={MaskType.TopBulge}
          imageContent={
            <div className="z-10 relative w-full h-full bg-deep-blue rounded-t-[1.25rem]">
              <div className="relative h-[85px] overflow-visible flex flex-col items-center">
                <div
                  className="h-[160px] aspect-square rounded-[50%] p-2 bg-bright-cyan absolute -top-[100%]"
                >
                  {authorImage &&
                  ( <img src={authorImage} className="w-full h-full rounded-full object-contain" loading="lazy"/>)}
                </div>
              </div>
              <div className="h-1/2 relative w-full flex flex-col items-center text-white justify-end pb-10">
                <Iso
                  className={`${
                    isAtSpeaker && isAtSpeaker
                      ? "w-12 h-12 max-w-full absolute bottom-[151px] left-6 [&>*]:stroke-vibrant-green [&>*]:fill-vibrant-green"
                      : "hidden"
                  }`}
                />
                <p className="subtitle-3 text-center px-[1rem]">{authorName}</p>
                <p className="caption text-center px-[1rem]">{authorRole}</p>
                <div
                  className={`${
                    isSpeaker && isSpeaker ? "hidden" : ""
                  } flex flex-row flex-nowrap items-center pt-1 cursor-pointer`}
                >
                  <div className="mr-1">
                    <Bookmark />
                  </div>
                  <p className="font-ibmPlexSansSemiBold text-mobile-caption md:text-desktop-caption text-bright-cyan">
                    {`${numArticles} Articles`}
                  </p>
                </div>
              </div>
            </div>
          }
          textContent={
            <>
              {isSpeaker ? (
                <div className="relative w-full h-full">
                  <div
                    className="z-10 relative w-full h-full bg-white pt-6 rounded-b-[1.25rem]"
                    style={{ clipPath: "url(#section-top-bulge-mobile)" }}
                  >
                    <div className="w-full h-full flex flex-col px-5">
                      <p
                        title={title}
                        className="text-deep-blue subtitle-3 mb-[1rem] line-clamp-5"
                      >
                        {title}
                      </p>
                      <p
                        title={content}
                        className="text-deep-blue body line-clamp-13"
                      >
                        {content}
                      </p>
                    </div>
                    <>
                      <TopBulgemask />
                    </>
                  </div>
                </div>
              ) : (
                <div className="relative w-full h-full">
                  <div className="z-20 absolute w-full flex flex-col items-center top-[-1rem]">
                    <Tag
                      content={
                        <div className="flex flex-row flex-nowrap items-center py-1 ">
                          <p className="grow text-mobile-caption md:text-desktop-caption font-ibmPlexSansSemiBold">
                            Get Notifications
                          </p>
                          <div className="ml-2">
                            <Bell />
                          </div>
                        </div>
                      }
                      customColors="text-white bg-vibrant-green"
                      tagType={TagType.custom}
                      className="cursor-pointer hidden" // Remove hidden class when we have the feature for notifications
                    />
                  </div>
                  <div
                    className="z-10 relative w-full h-full bg-white pt-11 rounded-b-[1.25rem]"
                    style={{ clipPath: "url(#section-top-bulge-mobile)" }}
                  >
                    <div className="w-full h-full flex flex-col">
                      <p className="text-center subtitle-2-bold text-vibrant-green mb-[1rem]">
                        Author's Articles
                      </p>

                      {featuredArticles &&
                        featuredArticles.map((article, index) => (
                          <div
                            key={`articles-${index}`}
                            className="w-full flex flex-col "
                          >
                            <AuthorArticle image={article.thumbnail || { url: ''}} 
                              title={article.title} summary={article.summary} redirectTo={article.redirectTo || '#'} />
                          </div>
                        ))}
                    </div>
                    <>
                      <TopBulgemask />
                    </>
                  </div>
                </div>
              )}
            </>
          }
        />
      </div>
    );
  }
);

export default AuthorCardDesktop;
